exports.orderedChannels = [
    'audio',
    'display',
    'mobile',
    'native',
    'video',
];



// WEBPACK FOOTER //
// ./src/constants/siteDirect.js